module.exports = __webpack_public_path__ + "static/media/HUMANITARIAN-AID-CARGO-MOVEMENT.60d654a2.jpg";